import { Components, Theme } from '@mui/material/styles';

export const MuiSnackbarContent: Components<Omit<Theme, 'components'>>['MuiSnackbarContent'] = {
  styleOverrides: {
    root: {
      boxShadow: '0px 1px 3px 0px #0000004D',
    },
  },
};
